'use client';

import { c as _c } from "react/compiler-runtime";
import { INTEREST_OPTIONS, MONTH_OPTIONS } from '@/app/constants/calculator';
import { CalculatorConfigure } from '@/app/lcv/components/sections/calculator/configure';
import { type CalculatorHomeProps, useCalculatorHome } from '@/app/lcv/components/sections/calculator/home/useCalculatorHome';
import { CalculatorResult } from '@/app/lcv/components/sections/calculator/result';
import { getVehicleTypeFromCategory, parseFloatAndHandleNaN } from '@/app/lcv/components/sections/calculator/utility';
import { DMAX_DATA, MUX_DATA } from '@/app/lcv/contents/calculators.data';
import type { LcvModelSubCategory } from '@/types/tis-cms/types';
export type { CalculatorHomeProps };
export const CalculatorHome = props => {
  const $ = _c(45);
  const {
    modelCategories,
    tilVehicleModel,
    provinces,
    isSpecialCampaignOn
  } = props;
  const {
    view,
    setView,
    modelCategory,
    setModelCategory,
    listModelSubCategory,
    modelSubCategory,
    onSelectModelSubCategory,
    selectedModelCategoryListItems,
    model,
    setModel,
    listColor,
    color,
    setColor,
    percent,
    onChangePercent,
    payment,
    onChangePayment,
    price,
    selectedMonth,
    onChangeMonth,
    interest,
    setInterest,
    tilInterest,
    tilInterestList,
    interestType,
    setInterestType,
    isTilInterestType,
    onSubmit
  } = useCalculatorHome(props);
  let t0;
  if ($[0] !== color || $[1] !== interest || $[2] !== interestType || $[3] !== listColor || $[4] !== listModelSubCategory || $[5] !== model || $[6] !== modelCategories || $[7] !== modelCategory || $[8] !== modelSubCategory || $[9] !== onChangeMonth || $[10] !== onChangePayment || $[11] !== onChangePercent || $[12] !== onSelectModelSubCategory || $[13] !== onSubmit || $[14] !== payment || $[15] !== percent || $[16] !== price || $[17] !== selectedModelCategoryListItems || $[18] !== selectedMonth || $[19] !== setColor || $[20] !== setInterest || $[21] !== setInterestType || $[22] !== setModel || $[23] !== setModelCategory || $[24] !== tilVehicleModel || $[25] !== view) {
    t0 = view === "preview" && <CalculatorConfigure listModelCategory={modelCategories} modelCategory={modelCategory} onSelectCategory={setModelCategory} listModelSubCategory={listModelSubCategory as LcvModelSubCategory[]} modelSubCategory={modelSubCategory as LcvModelSubCategory} onSelectModelSubCategory={onSelectModelSubCategory} listModel={selectedModelCategoryListItems} model={model} onSelectModel={setModel} listColor={listColor} color={color} onSelectColor={setColor} percent={percent} onChangePercent={onChangePercent} payment={payment} onChangePayment={onChangePayment} price={price} listMonth={MONTH_OPTIONS} month={selectedMonth} onChangeMonth={onChangeMonth} tilVehicleModel={tilVehicleModel} interest={interest} listInterestType={INTEREST_OPTIONS} interestType={interestType} onChangeInterestType={setInterestType} onChangeInterest={setInterest} onSubmit={onSubmit} />;
    $[0] = color;
    $[1] = interest;
    $[2] = interestType;
    $[3] = listColor;
    $[4] = listModelSubCategory;
    $[5] = model;
    $[6] = modelCategories;
    $[7] = modelCategory;
    $[8] = modelSubCategory;
    $[9] = onChangeMonth;
    $[10] = onChangePayment;
    $[11] = onChangePercent;
    $[12] = onSelectModelSubCategory;
    $[13] = onSubmit;
    $[14] = payment;
    $[15] = percent;
    $[16] = price;
    $[17] = selectedModelCategoryListItems;
    $[18] = selectedMonth;
    $[19] = setColor;
    $[20] = setInterest;
    $[21] = setInterestType;
    $[22] = setModel;
    $[23] = setModelCategory;
    $[24] = tilVehicleModel;
    $[25] = view;
    $[26] = t0;
  } else {
    t0 = $[26];
  }
  let t1;
  if ($[27] !== color || $[28] !== interest || $[29] !== isSpecialCampaignOn || $[30] !== isTilInterestType || $[31] !== model || $[32] !== modelCategory || $[33] !== payment || $[34] !== price || $[35] !== provinces || $[36] !== selectedMonth || $[37] !== setView || $[38] !== tilInterest || $[39] !== tilInterestList || $[40] !== view) {
    t1 = view === "result" && <CalculatorResult modelCategory={modelCategory} model={model} color={color} price={price} payment={parseFloatAndHandleNaN(payment).toString()} interest={isTilInterestType ? tilInterest : interest} tilInterestList={tilInterestList} isTilLeasing={isTilInterestType} listMonth={MONTH_OPTIONS} month={selectedMonth} onReCalculate={() => setView("preview")} data={modelCategory.title === "mu-x" ? MUX_DATA : DMAX_DATA} vehicleType={getVehicleTypeFromCategory(modelCategory)} provinces={provinces} isSpecialCampaignOn={isSpecialCampaignOn} />;
    $[27] = color;
    $[28] = interest;
    $[29] = isSpecialCampaignOn;
    $[30] = isTilInterestType;
    $[31] = model;
    $[32] = modelCategory;
    $[33] = payment;
    $[34] = price;
    $[35] = provinces;
    $[36] = selectedMonth;
    $[37] = setView;
    $[38] = tilInterest;
    $[39] = tilInterestList;
    $[40] = view;
    $[41] = t1;
  } else {
    t1 = $[41];
  }
  let t2;
  if ($[42] !== t0 || $[43] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[42] = t0;
    $[43] = t1;
    $[44] = t2;
  } else {
    t2 = $[44];
  }
  return t2;
};